// search
var searchToggle = document.getElementById('search--toggle');
var searchContainer = document.getElementsByClassName('search--form')[0];
var body = document.getElementsByTagName("BODY")[0];

if (searchToggle && searchContainer) {
  searchToggle.addEventListener('click', function(e) {
    e.preventDefault();

    if ( searchToggle.classList.contains('open') ) {
        body.classList.remove('search--open');
        searchContainer.classList.remove('open');
        searchToggle.classList.remove('open');
        searchToggle.setAttribute( 'aria-expanded' , false );
    }

    else {
        body.classList.add('search--open');
        searchContainer.classList.add('open');
        searchToggle.classList.add('open');
        searchToggle.setAttribute( 'aria-expanded' , true );
    }

 });
}